import React, { useCallback, useState } from 'react';

import {
  bool, node, string,
} from 'prop-types';
import cn from 'classnames';
import { Icon } from '@picsio/ui';
import { BillInfo, TriangleArrowDown } from '@picsio/icons';

import Tooltip from '../../../Tooltip';
import productInfoStyles from '../../../ProductInfo/styles.module.scss';
import s from './styles.module.scss';

const CollapsibleGroup = ({
  title,
  titleIcon,
  titleInfo,
  defaultExpanded,
  contentClassName,
  dataQa,
  children,
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);
  const toggleExpanded = useCallback(() => {
    setIsExpanded((prev) => !prev);
  }, []);

  return (
    <div className={s.group} data-qa={dataQa}>
      <div
        className={s.groupHeader}
        role="button"
        tabIndex={0}
        onClick={toggleExpanded}
        onKeyDown={toggleExpanded}
      >
        <Icon
          size="lg"
          className={cn(s.groupChevron, { [s.groupChevronExpanded]: isExpanded })}
        >
          <TriangleArrowDown />
        </Icon>
        <If condition={titleIcon}>
          <span className={s.groupIcon}>{titleIcon}</span>
        </If>
        <span className={s.groupTitle}>{title}</span>
        <If condition={titleInfo}>
          <Tooltip content={titleInfo} placement="top">
            <span
              className={cn(s.groupInfo, productInfoStyles.masterStatusIcon)}
              aria-hidden
              onClick={(event) => event.stopPropagation()}
              onKeyDown={(event) => event.stopPropagation()}
            >
              <Icon size="md">
                <BillInfo />
              </Icon>
            </span>
          </Tooltip>
        </If>
      </div>
      <If condition={isExpanded}>
        <div className={contentClassName || s.groupContent}>
          {children}
        </div>
      </If>
    </div>
  );
};

CollapsibleGroup.propTypes = {
  title: string.isRequired,
  titleIcon: node,
  titleInfo: string,
  defaultExpanded: bool,
  contentClassName: string,
  dataQa: string,
  children: node.isRequired,
};

CollapsibleGroup.defaultProps = {
  titleIcon: null,
  titleInfo: null,
  defaultExpanded: false,
  contentClassName: null,
  dataQa: null,
};

export default CollapsibleGroup;
